import {Image} from "@nextui-org/react";
import FuelChart from "./charts/fuelConsumtionChart";
export const FuelConsumptionHeader: React.FC<any> = () => {
  return (
    <div className="flex h-[160px] items-stretch justify-between gap-2">
      <div className="w-[40%] rounded-lg border border-gray-300 p-2">
        <div className="grid grid-cols-2 gap-2">
          <StatCard
            icon="/icons/topArrow.svg"
            iconBg="bg-yellow-100"
            title="Fuel Filling"
            value="1"
            unit="KM"
          />
          <StatCard
            icon="/icons/alert.svg"
            iconBg="bg-yellow-100"
            title="Fuel Theft Alert"
            value="1"
            unit="KM"
          />
          <StatCard
            icon="/images/fuel_yellow.svg"
            iconBg="bg-yellow-100"
            title="Fuel Consumed"
            value="1"
            unit="KM"
          />
          <StatCard
            icon="/icons/distance.svg"
            iconBg="bg-yellow-100"
            title="Fuel Consumption"
            value="1"
            unit="KM"
          />
        </div>
      </div>
      <div className="w-[60%] p-2">
        <FuelChart />
      </div>
    </div>
  );
};

const StatCard = ({
  icon,
  iconBg,
  title,
  value,
  unit
}: {
  icon: string;
  iconBg: string;
  title: string;
  value: string | number;
  unit: string;
}) => (
  <div className="rounded-lg border border-gray-300 bg-white p-3">
    <div className="flex items-center gap-4">
      <div
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${iconBg}`}
      >
        <Image
          src={icon}
          alt=""
          width={20}
          height={20}
          className="block object-contain"
        />
      </div>

      <div className="min-w-0">
        <div className="truncate text-sm font-medium text-gray-600">
          {title}
        </div>
        <div className="flex items-baseline gap-1 font-bold text-gray-800">
          <span className="text-base leading-none">{value}</span>
          <span className="text-xs text-gray-600">{unit}</span>
        </div>
      </div>
    </div>
  </div>
);
